// VX: temporizador del carrito.
// - Con minutos (data-minutes > 0): cuenta atrás desde que se añade el primer producto; al llegar a 0 la barra
//   desaparece y no vuelve mientras el carrito siga activo. Si el carrito se vacía, la próxima vez empieza de nuevo.
// - Con 0 minutos: cronómetro hacia arriba (tiempo desde el primer producto), como antes.
// Funciona aunque el carrito lateral se vuelva a dibujar (busca el elemento en cada segundo).
(function () {
  var KEY = 'vxCartStartedAt';
  var pad = function (n) { return String(n).padStart(2, '0'); };

  function read() {
    try { return Number(localStorage.getItem(KEY)) || 0; } catch (e) { return 0; }
  }
  function write(v) {
    try { if (v) { localStorage.setItem(KEY, String(v)); } else { localStorage.removeItem(KEY); } } catch (e) {}
  }
  function fmt(secs) {
    var h = Math.floor(secs / 3600);
    var m = Math.floor((secs % 3600) / 60);
    var s = secs % 60;
    return h > 0 ? h + ':' + pad(m) + ':' + pad(s) : pad(m) + ':' + pad(s);
  }

  function tick() {
    var el = document.querySelector('.vx-cart-timer');
    if (!el) return;
    var count = Number(el.getAttribute('data-count')) || 0;
    var minutes = Number(el.getAttribute('data-minutes')) || 0;
    var started = read();

    if (count === 0) {
      if (started) write(0);
      el.hidden = true;
      return;
    }
    if (!started) {
      started = Date.now();
      write(started);
    }
    var elapsed = Math.max(0, Math.floor((Date.now() - started) / 1000));
    var out;
    if (minutes > 0) {
      var left = minutes * 60 - elapsed;
      if (left <= 0) {
        el.hidden = true;
        return;
      }
      out = fmt(left);
    } else {
      out = fmt(elapsed);
    }
    var t = el.querySelector('.vx-cart-timer__time');
    if (t && t.textContent !== out) t.textContent = out;
    el.hidden = false;
  }

  tick();
  setInterval(tick, 1000);
})();
